/** Activist Insight Governance (AiG) — used for Disclosure Search, Interlocks, etc. */
export const GOVERNANCE_PRODUCT_ID = 6;

/** Compensation product — P4P Snapshot, TSR Calculator, Peer Composer, etc. */
export const COMPENSATION_PRODUCT_ID = 7;

/**
 * Membership status on the product subscription (tbl-style).
 * Aligns with client `TRIAL_USER` / `FULL_USER` in NumberConstants.
 */
export const PRODUCT_MEMBERSHIP_TRIAL = 2;
export const PRODUCT_MEMBERSHIP_FULL = 4;

/** Same access level as FEATURE_ACCESS_ENABLED / FEATURE_ACCESS_LIMITED for feature-gated tools. */
export const PRODUCT_ACCESS_ALLOWED_STATUSES = [PRODUCT_MEMBERSHIP_TRIAL, PRODUCT_MEMBERSHIP_FULL] as const;
